import React, { useState, useEffect } from 'react'
import styles from './FluIndices.module.scss'
import getVectorImage from '../../utils/getVectorImage'
import { useGeoFetch } from '../../components/GeoProvider'
import typeDisplayOptions from '../Dashboard/typeDisplayOptions'
import SelectList from '../../components/SelectList'
import DefaultBreadcrumbs from '../../components/Breadcrumbs/DefaultBreadcrumbs'
import { useGeoState } from '../../components/GeoProvider'
import regionDisplayOptions from './regionDisplayOptions'
import diseaseDisplayOptions from './diseaseDisplayOptions'
import MapOptionsAllergies from '../../components/MapOptionsAllergies'
import DisplayDateAllergies from '../../components/DisplayDateFlu/DisplayDateAllergies'
import {lastDisplayDate} from './dates'
import toFixed from '../../utils/toFixed' 
const HeaderDisplay = ({ headerType,geo_id }) => {
  const [getgeoid, setgeoid] = useState('')
  const [getistrue, setistrue] = useState('')
  const [getDatavalue, setDatavalue] = useState('')
  const [getPercentage, setPercentage] = useState('')
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const {
    setLocationName,
    diseaseSelected,
  } = useGeoState()
  const { data: headerdata, error: stateDataError } = useGeoFetch(
    lastDisplayDate,
    lastDisplayDate,
    'allergiesheader',
    `${geo_id}/${diseaseSelected}`
  )
  useEffect(() => {
    if (headerdata !== null && headerdata !== undefined) {
      if (headerdata.response_code === 200) {
        if (
          headerdata.response_data !== null &&
          headerdata.response_data !== undefined
        ) {
           seterrorOccured(false)
          setLocationName(headerdata.response_data.statename)
          setgeoid(headerdata.response_data.geo_id)
          setistrue(headerdata.response_data.istrue)
          setPercentage(headerdata.response_data.percentage)
          setDatavalue(headerdata.response_data.data_value)
        }
      } else {
        setErrorSubject(headerdata.response_subject)
        seterrorOccured(true)
      }
    }
  }, [headerdata])
  if (stateDataError || errorOccured) {
    return (
      <div>
        {errorSubject !== undefined
          ? errorSubject
          : 'Unable to get the data for header'}{' '}
        : {errorSubject}
      </div>
    )
  }
  return (
    <>
      <span className={styles.firstSpan}> {getgeoid}</span>
      <span className={styles.secondSpan}>{getVectorImage(getistrue)}</span>
      <span className={getistrue ? styles.stdatavalueup : styles.datavaluedown}>
        {' '}
        {toFixed(getPercentage,2)}%{' '}
      </span>
      <span className={styles.forthSpan}> ({getDatavalue})</span>
    </>
  )
}

const Header = ({ headerType, headerNumber,geo_id }) => {
  const {
    setDiseaseSelected
  } = useGeoState()
  const [activeZip3, setactiveZip3] = useState()
  setDiseaseSelected(window.localStorage.getItem('disease'))
  const { data: activeZip3Data, error: activeZip3DataError } = useGeoFetch(
    '',
    '',
    'search',
    'locations/ALLERGIES',
    '',
    {
      'geo_type' : 'ZIP3'
    }
  )

  useEffect(() => {
    if (activeZip3Data !== null && activeZip3Data !== undefined) {
      setactiveZip3(activeZip3Data.response_data)
    }
  }, [activeZip3Data])
  return (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderText}>
          <DefaultBreadcrumbs
            geo_id={'NAT'}
            geo_type={'NAT'}
            dashboardType={'ALLERGIES'}
          />
          <SelectList
            dropdownData={typeDisplayOptions}
            defaultValue={'allergies'}
            defaultLabel={'Allergies and Air Quality'}
          />
          <div style={{marginTop:'-30px',fontSize:'14px'}}>
          <DisplayDateAllergies
                    showWeek={true}
                    diseaseType={'Allergies'}
                    location_name={'United States'}
                  />
            </div>
        </div>
        <div className={styles.pageHeaderTextValue}>
          <HeaderDisplay
            headerType={headerType}
            dashNo={headerNumber}
            geo_id={geo_id}
          ></HeaderDisplay>
        <MapOptionsAllergies 
          regionDisplayOptions={regionDisplayOptions} 
          diseaseDisplayOptions={diseaseDisplayOptions}
          activeZip3={activeZip3} 
          entity={'Allergies'}
          geo_type={headerType}

          /> 
          
        </div>
      </div>
    </>
  )
}
export default Header
